import { RootState, INITIAL_STATE } from "../core/state-shape";
import { http } from "../lib/http";
import { measure } from '@/lib/performance';
import { createProjectScopedStore } from './projectScoped';

export type ContextBundlesState = RootState["contextBundles"];

type ContextBundlesActions = {
  setState: (newState: ContextBundlesState) => void;
  patch: (p: Partial<ContextBundlesState>) => void;
  reset: () => void;
  build: (taskId: string) => Promise<string>;
  hydrate: (bundleId: string) => Promise<void>;
};

export const useContextBundlesStore = createProjectScopedStore<ContextBundlesState & ContextBundlesActions>('contextBundles', (set) => ({
  ...INITIAL_STATE.contextBundles,
  setState: (newState) => set(newState),
  patch: (p) => set(p),
  reset: () => set({ ...INITIAL_STATE.contextBundles }),

  build: measure(async (taskId) => {
    const res = await http<{ bundleId: string; items: any[]; tokensUsed: number; budget: { soft: number; hard: number } }>(
      `/api/context/build`,
      { method: "POST", body: JSON.stringify({ taskId }) }
    );
    
    set((state) => {
        const byId = { ...state.byId };
        byId[res.bundleId] = {
            id: res.bundleId,
            taskId,
            createdAt: new Date().toISOString(),
            items: res.items.map(i => ({ ...i, estimate: i.estimate ?? { tokens: 0 } })),
            tokensUsed: res.tokensUsed,
            budget: res.budget,
            locked: false,
        };
        return { byId };
    });

    return res.bundleId;
  }, 'contextBundles.build'),
  
  async hydrate(bundleId) {
      console.warn("hydrate not implemented in mock for context bundles");
  }
}));